import styled from 'styled-components';

import { P } from '../../typography';

/* ----------------------------- StyledPairingTemplate ----------------------------- */

/**
 * StyledPairingTemplate
 *
 *  Styles for spacing and centering elements in the StyledPairingTemplate
 */

export const StyledPairingTemplate = styled.div(
    ({ theme }) => `
    margin: 3rem 2rem;
    text-align: center;
    color: ${theme.sections.page.a};

    a {
        color: ${theme.sections.page.a};
    }

    > ${P}{
        max-width: 25rem;
        margin: 0 auto;
    }
`,
);

export const SuccessIcon = styled.i(
    ({ theme }) => `
    color: ${theme.sections.page.feature};
    margin-top: 1rem;

    &.fa {
        font-size: 8rem;

        @media screen and (min-width: 48rem) {
            font-size: 12rem;
        }
    }
`,
);
